import { isMongoId } from '../../helpers';
import { z } from 'zod';
import { LpInvestorClassificationStage } from 'further-types/lp/investor-classification';
import { CalendarDay } from '../../../utils';

export const SaveInvestorClassificationStageInput = z.object({
  vehicleApplicationId: z.string().refine(isMongoId()),
  investorClassificationTypeId: z.string().refine(isMongoId()),
  stage: z.nativeEnum(LpInvestorClassificationStage),
  answers: z.array(
    z.object({
      questionKey: z.string().min(1, 'Question key is required.'),
      questionText: z.string().min(1, 'Question text is required.'),
      answerKey: z.string().optional(),
      answerText: z.string(),
      answerDetailsKey: z.string().optional(),
      answerDetailsText: z.string().optional(),
      answerFiles: z
        .array(
          z.object({
            path: z.string().min(1, 'File path is required.'),
            name: z.string().min(1, 'File name is required.'),
          }),
        )
        .optional(),
    }),
  ),
  result: z.number().optional(),
  declaration: z
    .object({
      fullName: z.string(),
      signature: z.string(),
      date: z.instanceof(CalendarDay),
      capacity: z.string().optional(),
      files: z
        .array(
          z.object({
            path: z.string().min(1, 'File path is required.'),
            name: z.string().min(1, 'File name is required.'),
          }),
        )
        .optional(),
    })
    .optional(),
  isSubmit: z.boolean().optional().default(true),
});
